/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'ParallaxFullWidthBlock';
const CLS = 'parallaxFullWidthBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/parallaxFullWidthBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import utils from '../utils';

export class ParallaxFullWidthBlock {
	constructor($el) {
		// $el is the widget node return by the loadParallaxFullWidthBlock function
		this.$el = $el;
	}

	init() {
		const $wg = $(this.$el);
		let $imgWrapper = $wg.find(WG + 'image');
		let $img = $wg.find('img');
		let src = $img.attr('src');

		$img.addClass('d-none');

		$imgWrapper.css({
			backgroundImage: `url(${src})`,
		});

		if (!utils.isIOS() && !utils.isAndroid() && !utils.isSmallerThanTablet()) {
			if ($wg.hasClass('js-parallax')) {
				$imgWrapper.css({
					backgroundImage: '',
				});

				$img.removeClass('d-none').addClass('jarallax-img');
				$imgWrapper.addClass('jarallax');

				if (window.jarallaxLoaded) {
					// eslint-disable-next-line no-undef
					jarallax($wg[0].querySelectorAll('.jarallax'));
				} else {
					$.getScript('https://unpkg.com/jarallax@1/dist/jarallax.min.js')
					.done(() => {
						window.jarallaxLoaded = true;
						// eslint-disable-next-line no-undef
						jarallax($wg[0].querySelectorAll('.jarallax'));
					});
				}
			} else {
				$imgWrapper.css({
					backgroundAttachment: 'fixed',
				});
			}
		}
	}

	// Add more functions like on above here
}
